import React from 'react'

const Quote = ({children}) => (
  <blockquote className="max-w-xl bg-gray-200 border border-gray-400 p-0 shadow-inner text-sm rounded">{children}</blockquote>
)

export default Quote
